module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-main-d91995fa9831e9c02c1507c5cfee1862.jpg";